export default __webpack_public_path__ + "static/client-4-37800840cf34bf3a0a9e552ce87c66f3.jpg";